const StatusBarComponent = {
  restrict: 'E',
  template: require('./status-bar.html'),
  bindings: {
    min: '<',
    max: '<',
    lowerThreshold: '<',
    upperThreshold: '<',
    current: '<',
    orientation: '@',
    foregroundColor: '<?',
    backgroundColor: '<?'
  },
  controllerAs: 'vm',
  controller: [StatusBarController]
};

function StatusBarController() {
  let vm = this;
  vm.lowerThresholdPercentage = 0;
  vm.upperThresholdPercentage = 100;
  vm.width = 'inherit';
  vm.height = 'inherit';

  vm.$onInit = function() {};

  vm.$onChanges = function(change) {
    if (change.lowerThreshold && change.lowerThreshold.currentValue) {
      const lower = change.lowerThreshold.currentValue;
      vm.lowerThresholdPercentage = (lower - vm.min) * 100 / (vm.max - vm.min);
    }

    if (change.upperThreshold && change.upperThreshold.currentValue) {
      const upper = change.upperThreshold.currentValue;
      vm.upperThresholdPercentage = (upper - vm.min) * 100 / (vm.max - vm.min);
    }
    if (change.current && change.current.currentValue) {
      let value = change.current.currentValue;
      let percentage = (value - vm.min) * 100 / (vm.max - vm.min) + '%';

      if (vm.orientation === 'horizontal') {
        vm.width = percentage;
        vm.height = 'inherit';
      } else {
        vm.height = percentage;
        vm.width = 'inherit';
      }
    }
  };
}

export default StatusBarComponent;
